/* eslint-disable @typescript-eslint/typedef */
// Generated Figma variables (from local JSON)
// Do not add anything manually, all changes will be overwritten on the next generation.

// Primitive tokens (per brand); keys should appear in at least one other brand.
export const primitiveTsCssVars = {
  'accent-0': 'rgba(243, 62, 75, 0.0)',
  'accent-10': '#fee7e9',
  'accent-100': 'rgba(243, 62, 75, 0.10)',
  'accent-20': '#fccfd2',
  'accent-30': '#f99fa5',
  'accent-40': '#f66f79',
  'accent-50': '#f33e4b',
  'accent-60': '#f00f1f',
  'accent-70': '#c00c19',
  'accent-80': '#900913',
  'accent-90': '#60060c',
  'black-0': 'rgba(0, 0, 0, 0.0)',
  'black-10': 'rgba(0, 0, 0, 0.10)',
  'black-100': '#000000',
  'black-20': 'rgba(0, 0, 0, 0.20)',
  'black-30': 'rgba(0, 0, 0, 0.30)',
  'black-40': 'rgba(0, 0, 0, 0.40)',
  'black-50': 'rgba(0, 0, 0, 0.50)',
  'black-60': 'rgba(0, 0, 0, 0.60)',
  'black-70': 'rgba(0, 0, 0, 0.70)',
  'black-80': 'rgba(0, 0, 0, 0.80)',
  'black-90': 'rgba(0, 0, 0, 0.90)',
  'brand-0': 'rgba(255, 180, 0, 0.0)',
  'brand-10': '#fff0cc',
  'brand-100': 'rgba(255, 180, 0, 0.10)',
  'brand-20': '#ffe199',
  'brand-30': '#ffd266',
  'brand-40': '#ffc333',
  'brand-50': '#ffb400',
  'brand-60': '#cc9000',
  'brand-70': '#996c00',
  'brand-80': '#664800',
  'brand-85': '#332400',
  'error-0': 'rgba(243, 62, 75, 0.0)',
  'error-10': '#fee7e9',
  'error-100': 'rgba(243, 62, 75, 0.10)',
  'error-20': '#fccfd2',
  'error-30': '#f99fa5',
  'error-40': '#f66f79',
  'error-50': '#f33e4b',
  'error-60': '#f00f1f',
  'error-70': '#c00c19',
  'error-80': '#900913',
  'error-90': '#60060c',
  'info-0': 'rgba(51, 68, 255, 0.0)',
  'info-10': '#d6daff',
  'info-100': 'rgba(51, 68, 255, 0.10)',
  'info-20': '#adb4ff',
  'info-30': '#858fff',
  'info-40': '#5c69ff',
  'info-50': '#3344ff',
  'info-60': '#2936cc',
  'info-70': '#1f2999',
  'info-80': '#141b66',
  'info-90': '#0a0e33',
  'neutral-0': 'rgba(12, 59, 46, 0.0)',
  'neutral-10': '#ecf3f1',
  'neutral-100': 'rgba(12, 59, 46, 0.10)',
  'neutral-20': '#cce1db',
  'neutral-30': '#a6d3c7',
  'neutral-40': '#79cdb6',
  'neutral-50': '#26ba91',
  'neutral-60': '#1d9070',
  'neutral-70': '#15664f',
  'neutral-80': '#0c3b2e',
  'neutral-85': '#08261e',
  'neutral-90': '#03110d',
  'radius-1': 4,
  'radius-10': 56,
  'radius-2': 8,
  'radius-3': 12,
  'radius-4': 16,
  'radius-5': 20,
  'radius-6': 24,
  'radius-7': 32,
  'radius-8': 40,
  'radius-9': 48,
  'radius-999': 999,
  'space-1': 4,
  'space-10': 56,
  'space-11': 64,
  'space-12': 80,
  'space-13': 96,
  'space-14': 128,
  'space-15': 160,
  'space-16': 192,
  'space-17': 224,
  'space-18': 256,
  'space-19': 512,
  'space-2': 8,
  'space-3': 12,
  'space-4': 16,
  'space-5': 20,
  'space-6': 24,
  'space-7': 32,
  'space-8': 40,
  'space-9': 48,
  'success-0': 'rgba(76, 175, 80, 0.0)',
  'success-10': '#dbefdc',
  'success-100': 'rgba(76, 175, 80, 0.10)',
  'success-20': '#b7dfb9',
  'success-30': '#94cf96',
  'success-40': '#70bf73',
  'success-50': '#4caf50',
  'success-60': '#3d8c40',
  'success-70': '#2e6930',
  'success-80': '#1e4620',
  'success-90': '#0f2310',
  'warning-0': 'rgba(255, 152, 0, 0.0)',
  'warning-10': '#ffeacc',
  'warning-100': 'rgba(255, 152, 0, 0.10)',
  'warning-20': '#ffd699',
  'warning-30': '#ffc166',
  'warning-40': '#ffad33',
  'warning-50': '#ff9800',
  'warning-60': '#cc7a00',
  'warning-70': '#995b00',
  'warning-80': '#663d00',
  'warning-90': '#331e00',
  'white-0': 'rgba(255, 255, 255, 0.0)',
  'white-10': 'rgba(255, 255, 255, 0.10)',
  'white-100': '#ffffff',
  'white-20': 'rgba(255, 255, 255, 0.20)',
  'white-30': 'rgba(255, 255, 255, 0.30)',
  'white-40': 'rgba(255, 255, 255, 0.40)',
  'white-50': 'rgba(255, 255, 255, 0.50)',
  'white-60': 'rgba(255, 255, 255, 0.60)',
  'white-70': 'rgba(255, 255, 255, 0.70)',
  'white-80': 'rgba(255, 255, 255, 0.80)',
  'white-90': 'rgba(255, 255, 255, 0.90)',
  'yellow-0': 'rgba(251, 205, 0, 0.0)',
  'yellow-10': '#fffefa',
  'yellow-100': 'rgba(251, 205, 0, 0.10)',
  'yellow-20': '#fff4c7',
  'yellow-30': '#ffeb94',
  'yellow-40': '#ffe161',
  'yellow-50': '#ffd72e',
  'yellow-60': '#fbcd00',
  'yellow-70': '#c7a100',
  'yellow-80': '#947800',
  'yellow-90': '#614e00'
} as const;

// Semantic tokens; the same keys must exist for every brand (values may differ).
export const semanticTsCssVars = {
  'background-accent': '#f33e4b',
  'background-body': '#ecf3f1',
  'background-brand': '#ffb400',
  'background-primary': '#ffffff',
  'background-primary-inverse': '#0c3b2e',
  'background-primary-object': '#ffffff',
  'background-quaternary': '#a6d3c7',
  'background-secondary': '#ecf3f1',
  'background-state-accent': '#f33e4b',
  'background-state-accent-subtle': '#fee7e9',
  'background-state-brand': '#ffb400',
  'background-state-brand-subtle': '#fff0cc',
  'background-state-error': '#f33e4b',
  'background-state-error-subtle': '#fee7e9',
  'background-state-info': '#3344ff',
  'background-state-info-subtle': '#d6daff',
  'background-state-neutral': 'rgba(0, 0, 0, 0.60)',
  'background-state-neutral-subtle': '#cce1db',
  'background-state-success': '#4caf50',
  'background-state-success-subtle': '#dbefdc',
  'background-state-warning': '#ffb400',
  'background-state-warning-subtle': '#fff0cc',
  'background-tertiary': '#cce1db',
  'border-accent': '#f33e4b',
  'border-brand': '#ffb400',
  'border-primary': '#cce1db',
  'border-secondary': '#03110d',
  'border-state-error': '#f33e4b',
  'border-state-info': '#3344ff',
  'border-state-success': '#4caf50',
  'border-state-warning': '#ff9800',
  'border-tertiary': '#03110d',
  'components-badges-badge-bg-error': '#fee7e9',
  'components-badges-badge-bg-info': '#d6daff',
  'components-badges-badge-bg-success': '#dbefdc',
  'components-badges-badge-bg-warning': '#fff0cc',
  'components-badges-badge-fg-error': '#f33e4b',
  'components-badges-badge-fg-info': '#3344ff',
  'components-badges-badge-fg-success': '#4caf50',
  'components-badges-badge-fg-warning': '#ff9800',
  'components-badges-badge-icon-error-bg': '#fee7e9',
  'components-badges-badge-icon-error-fg': '#f33e4b',
  'components-badges-badge-icon-info-bg': '#d6daff',
  'components-badges-badge-icon-info-fg': '#3344ff',
  'components-badges-badge-icon-neutral-bg': '#cce1db',
  'components-badges-badge-icon-neutral-fg': '#15664f',
  'components-badges-badge-icon-primary-bg': '#fff0cc',
  'components-badges-badge-icon-primary-fg': '#ffb400',
  'components-badges-badge-icon-success-bg': '#dbefdc',
  'components-badges-badge-icon-success-fg': '#4caf50',
  'components-badges-badge-icon-warning-bg': '#fff0cc',
  'components-badges-badge-icon-warning-fg': '#ff9800',
  'components-badges-badge-tag-bg-accent': '#f33e4b',
  'components-badges-badge-tag-bg-accent-invert': '#fee7e9',
  'components-badges-badge-tag-bg-dark': 'rgba(0, 0, 0, 0.60)',
  'components-badges-badge-tag-bg-dark-invert': '#cce1db',
  'components-badges-badge-tag-bg-error': '#f33e4b',
  'components-badges-badge-tag-bg-error-invert': '#fee7e9',
  'components-badges-badge-tag-bg-info': '#3344ff',
  'components-badges-badge-tag-bg-info-invert': '#d6daff',
  'components-badges-badge-tag-bg-neutral': 'rgba(0, 0, 0, 0.60)',
  'components-badges-badge-tag-bg-neutral-invert': '#cce1db',
  'components-badges-badge-tag-bg-primary': '#f33e4b',
  'components-badges-badge-tag-bg-primary-invert': '#fee7e9',
  'components-badges-badge-tag-bg-success': '#4caf50',
  'components-badges-badge-tag-bg-success-invert': '#dbefdc',
  'components-badges-badge-tag-bg-warning': '#ffb400',
  'components-badges-badge-tag-bg-warning-invert': '#fff0cc',
  'components-badges-badge-tag-fg-accent': '#ecf3f1',
  'components-badges-badge-tag-fg-accent-invert': '#f33e4b',
  'components-badges-badge-tag-fg-dark': '#ffffff',
  'components-badges-badge-tag-fg-dark-invert': '#03110d',
  'components-badges-badge-tag-fg-error': '#ecf3f1',
  'components-badges-badge-tag-fg-error-invert': '#f33e4b',
  'components-badges-badge-tag-fg-info': '#ffffff',
  'components-badges-badge-tag-fg-info-invert': '#3344ff',
  'components-badges-badge-tag-fg-neutral': '#ffffff',
  'components-badges-badge-tag-fg-neutral-invert': '#03110d',
  'components-badges-badge-tag-fg-primary': '#ecf3f1',
  'components-badges-badge-tag-fg-primary-invert': '#f33e4b',
  'components-badges-badge-tag-fg-success': '#ecf3f1',
  'components-badges-badge-tag-fg-success-invert': '#4caf50',
  'components-badges-badge-tag-fg-warning': '#ecf3f1',
  'components-badges-badge-tag-fg-warning-invert': '#ff9800',
  'components-bottom-bar-bg': '#0c3b2e',
  'components-bottom-bar-bg-button': '#f33e4b',
  'components-bottom-bar-fg': '#ecf3f1',
  'components-bottom-bar-fg-button': '#ffffff',
  'components-bottom-bar-icon-active': '#ffb400',
  'components-bottom-bar-text-active': '#ffb400',
  'components-button-primary-bg': '#ffb400',
  'components-button-primary-bg-hover': '#cc9000',
  'components-button-primary-fg': '#03110d',
  'components-button-quaternary-bg': '#cce1db',
  'components-button-quaternary-bg-hover': '#a6d3c7',
  'components-button-quaternary-fg': '#03110d',
  'components-button-quaternary-fg-hover': '#03110d',
  'components-button-secondary-bg': '#f33e4b',
  'components-button-secondary-bg-hover': '#f33e4b',
  'components-button-secondary-border': '#f33e4b',
  'components-button-secondary-border-hover': '#f00f1f',
  'components-button-secondary-fg': '#ecf3f1',
  'components-button-secondary-fg-hover': '#ecf3f1',
  'components-button-tertiary-bg': '#ffffff',
  'components-button-tertiary-bg-hover': '#ecf3f1',
  'components-button-tertiary-fg': '#03110d',
  'components-dropdown-bg': '#ffffff',
  'components-dropdown-bg-hover': '#ecf3f1',
  'components-dropdown-text': '#03110d',
  'components-dropdown-text-active': '#f33e4b',
  'components-dropdown-text-disabled': '#cce1db',
  'components-footer-bg': '#ffffff',
  'components-footer-border': '#cce1db',
  'components-footer-text': '#15664f',
  'components-game-topbar-bg-primary': '#ecf3f1',
  'components-game-topbar-bg-secondary': '#ecf3f1',
  'components-game-topbar-button-bg': '#ffffff',
  'components-game-topbar-button-fg': '#0c3b2e',
  'components-game-topbar-toggle-bg-active': '#0c3b2e',
  'components-game-topbar-toggle-bg-disabled': '#cce1db',
  'components-game-topbar-toggle-fg-active': '#0c3b2e',
  'components-game-topbar-toggle-fg-disabled': '#a6d3c7',
  'components-game-topbar-toggle-icon-active': '#ffffff',
  'components-game-topbar-toggle-icon-disabled': '#ffffff',
  'components-hamburger-bg-primary': '#ffffff',
  'components-hamburger-bg-secondary': '#ecf3f1',
  'components-hamburger-text-primary': '#03110d',
  'components-hamburger-text-secondary': '#08261e',
  'components-input-bg-disabled': '#ecf3f1',
  'components-input-border': '#cce1db',
  'components-input-border-focus': '#03110d',
  'components-input-border-hover': '#a6d3c7',
  'components-input-fg-disabled': '#0c3b2e',
  'components-input-fg-error': '#f33e4b',
  'components-input-fg-primary': '#03110d',
  'components-input-fg-secondary': '#08261e',
  'components-menu-item-hamburger-bg-active': '#ecf3f1',
  'components-menu-item-hamburger-bg-hover': '#ecf3f1',
  'components-menu-item-hamburger-icon-active': '#1d9070',
  'components-menu-item-hamburger-icon-disabled': '#15664f',
  'components-menu-item-hamburger-icon-primary': '#1d9070',
  'components-menu-item-hamburger-icon-secondary': '#1d9070',
  'components-menu-item-hamburger-text': '#03110d',
  'components-menu-item-hamburger-text-active': '#03110d',
  'components-menu-item-hamburger-text-disabled': '#15664f',
  'components-menu-item-section-bg-active': '#ecf3f1',
  'components-menu-item-section-bg-hover': '#ecf3f1',
  'components-menu-item-section-icon-active': '#1d9070',
  'components-menu-item-section-icon-disabled': '#15664f',
  'components-menu-item-section-icon-primary': '#1d9070',
  'components-menu-item-section-icon-secondary': '#1d9070',
  'components-menu-item-section-text': '#03110d',
  'components-menu-item-section-text-active': '#03110d',
  'components-menu-item-section-text-disabled': '#15664f',
  'components-menu-item-sidebar-bg-active': '#08261e',
  'components-menu-item-sidebar-bg-hover': '#08261e',
  'components-menu-item-sidebar-icon-active': '#ffb400',
  'components-menu-item-sidebar-icon-disabled': '#15664f',
  'components-menu-item-sidebar-icon-primary': '#1d9070',
  'components-menu-item-sidebar-icon-secondary': '#1d9070',
  'components-menu-item-sidebar-text': '#ecf3f1',
  'components-menu-item-sidebar-text-active': '#ecf3f1',
  'components-menu-item-sidebar-text-disabled': '#15664f',
  'components-modals-bg-body': '#ffffff',
  'components-modals-bg-button': '#ffffff',
  'components-modals-bg-button-inverse': '#0c3b2e',
  'components-modals-bg-footer': '#ffffff',
  'components-modals-bg-footer-secondary': '#ecf3f1',
  'components-modals-bg-header': '#ffffff',
  'components-modals-bg-header-button': '#ffffff',
  'components-modals-bg-header-button-hover': '#ecf3f1',
  'components-modals-bg-header-inverse': '#0c3b2e',
  'components-modals-bg-header-inverse-button': '#0c3b2e',
  'components-modals-bg-header-inverse-button-hover': '#0c3b2e',
  'components-modals-bg-overlay': 'rgba(0, 0, 0, 0.80)',
  'components-modals-fg-header': '#03110d',
  'components-modals-fg-header-button': '#0c3b2e',
  'components-modals-fg-header-button-hover': '#0c3b2e',
  'components-modals-fg-header-inverse': '#ecf3f1',
  'components-modals-fg-header-inverse-button': '#ffffff',
  'components-modals-fg-header-inverse-button-hover': '#ffffff',
  'components-prize-progress-bg': '#cce1db',
  'components-prize-progress-bg-active': '#ffb400',
  'components-prize-progress-bg-disabled': '#ffffff',
  'components-prize-progress-fg': '#03110d',
  'components-prize-progress-fg-active': '#ffffff',
  'components-prize-progress-fg-disabled': '#cce1db',
  'components-scroll-bg': '#cce1db',
  'components-scroll-bg-hover': '#a6d3c7',
  'components-sidebar-bg-body': '#0c3b2e',
  'components-step-item-bg': '#ecf3f1',
  'components-step-item-counter-bg': '#ffb400',
  'components-step-item-counter-fg': '#ffffff',
  'components-step-item-fg': '#03110d',
  'components-step-item-fg-secondary': '#08261e',
  'components-tab-circle-bg': '#ffffff',
  'components-tab-circle-bg-hover': '#cce1db',
  'components-tab-circle-border': '#ecf3f1',
  'components-tab-circle-border-active': '#ffb400',
  'components-tab-circle-counter-bg': '#ffb400',
  'components-tab-circle-counter-text': '#ecf3f1',
  'components-tab-circle-fg': '#03110d',
  'components-tab-circle-fg-active': '#f33e4b',
  'components-tab-circle-fg-disabled': '#a6d3c7',
  'components-tab-horizontal-bg': '#ffffff',
  'components-tab-horizontal-bg-active': '#ffb400',
  'components-tab-horizontal-bg-highlighted': '#ffb400',
  'components-tab-horizontal-bg-hover': '#cce1db',
  'components-tab-horizontal-counter-bg': '#ffb400',
  'components-tab-horizontal-counter-bg-active': '#cce1db',
  'components-tab-horizontal-counter-text': '#ecf3f1',
  'components-tab-horizontal-counter-text-active': '#03110d',
  'components-tab-horizontal-fg': '#03110d',
  'components-tab-horizontal-fg-active': '#ecf3f1',
  'components-tab-horizontal-fg-disabled': '#a6d3c7',
  'components-tab-horizontal-fg-highlighted': '#ecf3f1',
  'components-tab-underline-border': '#cce1db',
  'components-tab-underline-border-active': '#f33e4b',
  'components-tab-underline-border-disabled': '#cce1db',
  'components-tab-underline-border-hover': '#03110d',
  'components-tab-underline-counter-bg': '#ffb400',
  'components-tab-underline-counter-text': '#ecf3f1',
  'components-tab-underline-fg': '#03110d',
  'components-tab-underline-fg-active': '#f33e4b',
  'components-tab-underline-fg-disabled': '#a6d3c7',
  'components-tab-vertical-bg': 'rgba(255, 255, 255, 0.10)',
  'components-tab-vertical-bg-active': 'rgba(255, 180, 0, 0.10)',
  'components-tab-vertical-bg-highlighted': '#ffb400',
  'components-tab-vertical-bg-hover': 'rgba(255, 255, 255, 0.20)',
  'components-tab-vertical-counter-bg': '#ffb400',
  'components-tab-vertical-counter-text': '#ecf3f1',
  'components-tab-vertical-fg': '#ecf3f1',
  'components-tab-vertical-fg-active': '#ffb400',
  'components-tab-vertical-fg-disabled': '#a6d3c7',
  'components-tab-vertical-fg-highlighted': '#ecf3f1',
  'components-tag-bg': '#cce1db',
  'components-tag-bg-active': '#0c3b2e',
  'components-tag-bg-disabled': '#ecf3f1',
  'components-tag-bg-hover': '#a6d3c7',
  'components-tag-text': '#03110d',
  'components-tag-text-active': '#ecf3f1',
  'components-tag-text-disabled': '#79cdb6',
  'components-toggles-bg-active': '#0c3b2e',
  'components-toggles-border': '#03110d',
  'components-toggles-disabled': '#79cdb6',
  'components-toggles-fg': '#ffffff',
  'components-toggles-switch-bg': '#cce1db',
  'components-toggles-switch-bg-selected-disabled': '#79cdb6',
  'components-toggles-switch-fg-disabled': '#ecf3f1',
  'components-tooltips-bg': '#0c3b2e',
  'components-tooltips-text': '#ecf3f1',
  'components-top-bar-bg': '#ecf3f1',
  'components-top-bar-bg-button': '#ffffff',
  'components-top-bar-bg-button-active': '#ffb400',
  'components-top-bar-fg-button-active': '#ecf3f1',
  'components-top-bar-fg-button-primary': '#03110d',
  'components-top-bar-fg-button-secondary': '#ffb400',
  'font-family-body': 'Poppins',
  'font-family-heading': 'DunkelSans',
  'font-family-title': 'Poppins',
  'font-letter-spacing-body-10': -0.20000000298023224,
  'font-letter-spacing-body-12': -0.23999999463558197,
  'font-letter-spacing-body-14': -0.2800000011920929,
  'font-letter-spacing-body-16': -0.3199999928474426,
  'font-letter-spacing-body-18': -0.36000001430511475,
  'font-letter-spacing-body-20': -0.4000000059604645,
  'font-letter-spacing-body-24': -0.47999998927116394,
  'font-letter-spacing-body-8': -0.1599999964237213,
  'font-letter-spacing-heading-10': -0.20000000298023224,
  'font-letter-spacing-heading-12': -0.23999999463558197,
  'font-letter-spacing-heading-14': -0.2800000011920929,
  'font-letter-spacing-heading-16': -0.3199999928474426,
  'font-letter-spacing-heading-18': -0.36000001430511475,
  'font-letter-spacing-heading-20': -0.4000000059604645,
  'font-letter-spacing-heading-24': -0.47999998927116394,
  'font-letter-spacing-heading-32': -0.6399999856948853,
  'font-letter-spacing-heading-36': -0.7200000286102295,
  'font-letter-spacing-heading-8': -0.1599999964237213,
  'font-letter-spacing-title-10': -0.20000000298023224,
  'font-letter-spacing-title-12': -0.23999999463558197,
  'font-letter-spacing-title-14': -0.2800000011920929,
  'font-letter-spacing-title-16': -0.3199999928474426,
  'font-letter-spacing-title-18': -0.36000001430511475,
  'font-letter-spacing-title-20': -0.4000000059604645,
  'font-letter-spacing-title-24': -0.47999998927116394,
  'font-letter-spacing-title-8': -0.1599999964237213,
  'font-line-height-body-10': 15,
  'font-line-height-body-12': 18,
  'font-line-height-body-14': 21,
  'font-line-height-body-16': 24,
  'font-line-height-body-18': 27,
  'font-line-height-body-20': 30,
  'font-line-height-body-24': 36,
  'font-line-height-body-8': 12,
  'font-line-height-heading-10': 12,
  'font-line-height-heading-12': 18,
  'font-line-height-heading-14': 17,
  'font-line-height-heading-16': 19,
  'font-line-height-heading-18': 22,
  'font-line-height-heading-20': 24,
  'font-line-height-heading-24': 29,
  'font-line-height-heading-32': 38,
  'font-line-height-heading-36': 43,
  'font-line-height-heading-8': 10,
  'font-line-height-title-10': 12,
  'font-line-height-title-12': 18,
  'font-line-height-title-14': 17,
  'font-line-height-title-16': 19,
  'font-line-height-title-18': 22,
  'font-line-height-title-20': 24,
  'font-line-height-title-24': 29,
  'font-line-height-title-8': 10,
  'font-size-body-10': 10,
  'font-size-body-12': 12,
  'font-size-body-14': 14,
  'font-size-body-16': 16,
  'font-size-body-18': 18,
  'font-size-body-20': 20,
  'font-size-body-24': 24,
  'font-size-body-8': 8,
  'font-size-heading-10': 10,
  'font-size-heading-12': 12,
  'font-size-heading-14': 14,
  'font-size-heading-16': 16,
  'font-size-heading-18': 18,
  'font-size-heading-20': 20,
  'font-size-heading-24': 24,
  'font-size-heading-32': 32,
  'font-size-heading-36': 36,
  'font-size-heading-8': 8,
  'font-size-title-10': 10,
  'font-size-title-12': 12,
  'font-size-title-14': 14,
  'font-size-title-16': 16,
  'font-size-title-18': 18,
  'font-size-title-20': 20,
  'font-size-title-24': 24,
  'font-size-title-8': 8,
  'font-weight-bold': 'Bold',
  'font-weight-extrabold': 'SemiCondensed Rounded',
  'font-weight-regular': 'Regular',
  'gradient-body': 'rgba(255, 255, 255, 0.0)',
  'gradient-bottom': 'rgba(255, 255, 255, 0.0)',
  'gradient-light-bottom': 'rgba(255, 255, 255, 0.0)',
  'gradient-light-left': 'rgba(255, 255, 255, 0.0)',
  'gradient-light-right': 'rgba(255, 255, 255, 0.0)',
  'gradient-top': 'rgba(255, 255, 255, 0.0)',
  'icon-accent': '#f33e4b',
  'icon-accent-subtle': '#fee7e9',
  'icon-brand': '#ffb400',
  'icon-brand-subtle': '#fff0cc',
  'icon-primary': '#03110d',
  'icon-primary-inverse': '#ffffff',
  'icon-secondary': '#15664f',
  'icon-secondary-subtle': '#cce1db',
  'icon-state-error': '#f33e4b',
  'icon-state-error-subtle': '#fee7e9',
  'icon-state-info': '#3344ff',
  'icon-state-info-subtle': '#d6daff',
  'icon-state-success': '#4caf50',
  'icon-state-success-subtle': '#dbefdc',
  'icon-state-warning': '#ff9800',
  'icon-state-warning-subtle': '#ffeacc',
  'radius-components-badge': 999,
  'radius-components-button': 999,
  'radius-components-input': 999,
  'radius-components-sidebar-nav': 999,
  'radius-components-tag-medium': 999,
  'radius-components-tag-small': 999,
  'radius-primary': 24,
  'radius-quaternary': 8,
  'radius-rounded': 999,
  'radius-secondary': 16,
  'radius-tertiary': 12,
  'text-accent': '#f33e4b',
  'text-brand': '#ffb400',
  'text-link': '#f33e4b',
  'text-link-disabled': '#15664f',
  'text-link-hover': '#f00f1f',
  'text-link-secondary': '#f33e4b',
  'text-link-secondary-disabled': '#15664f',
  'text-link-secondary-hover': '#f00f1f',
  'text-on-dark-image': '#ffffff',
  'text-on-light-image': '#03110d',
  'text-primary': '#03110d',
  'text-primary-inverse': '#ecf3f1',
  'text-quaternary': '#15664f',
  'text-secondary': '#08261e',
  'text-state-error': '#f33e4b',
  'text-state-info': '#3344ff',
  'text-state-success': '#4caf50',
  'text-state-warning': '#ff9800',
  'text-tertiary': '#0c3b2e'
} as const;

// Full map = primitives + semantics (primitives first, then semantics on key collision).
export const appTsCssVars = {
  ...primitiveTsCssVars,
  ...semanticTsCssVars
} as const;

export type PrimitiveTsCssVars = typeof primitiveTsCssVars;

export type SemanticTsCssVars = typeof semanticTsCssVars;

export type AppTsCssVars = typeof appTsCssVars;

export type PrimitiveTsCssVarKey = keyof PrimitiveTsCssVars;

export type SemanticTsCssVarKey = keyof SemanticTsCssVars;

export type AppTsCssVarKey = keyof AppTsCssVars;
